import React, { useEffect, useState } from "react";
import { getCategory } from "../../state/categoryState";
import { getRestaurant } from "../../state/restaurantState";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useGetImages from "../../components/useGetImages";
import MobresBacklink from "../../components/MobresBacklink";
import "./styles.css";

// Görselsiz kategoriler için isimden türetilen, sabit kalan yumuşak tonlar.
const TILE_TONES = ["#fdf0c4", "#fde2d2", "#e3eedb", "#dfe9f3", "#ece3f3", "#f6e0e6"];
const toneFor = (name = "") =>
  TILE_TONES[[...name].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % TILE_TONES.length];

const CategoryCard = React.memo(({ id, category }) => {
  const { image: uri, isLoading } = useGetImages("category_pictures", id, category?.CATEGORY);
  const [imgFailed, setImgFailed] = useState(false);

  if (!category) return null;

  const name = category.CATEGORY;
  const showImage = uri && !imgFailed;
  const showSkeleton = !uri && isLoading;

  return (
    <Link
      to={`/menu?category=${encodeURIComponent(name)}`}
      className={`ct-tile${showImage ? " ct-tile--photo" : ""}`}
      style={showImage || showSkeleton ? undefined : { background: toneFor(name) }}
    >
      {showImage && (
        <img src={uri} alt="" loading="lazy" className="ct-tile-img" onError={() => setImgFailed(true)} />
      )}
      {showSkeleton && <div className="ct-tile-img mn-skeleton" aria-hidden="true" />}
      {!showImage && !showSkeleton && (
        <span className="ct-tile-mono" aria-hidden="true">
          {name?.trim()?.charAt(0)?.toLocaleUpperCase("tr-TR")}
        </span>
      )}
      <span className="ct-tile-name">{name}</span>
    </Link>
  );
});

const Category = ({ id }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.categories.category);
  const restaurants = useSelector((state) => state.restaurants.restaurant);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    dispatch(getCategory({ path: id + "/categoryno.json" }));
    // getRestaurant "/restaurant.json" ekini kendisi yapar; sadece firma kodu verilir.
    dispatch(getRestaurant(id));
  }, [dispatch, id]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const restaurant = Array.isArray(restaurants) ? restaurants[0] : null;
  const hasCategories = Array.isArray(categories) && categories.length > 0;

  return (
    <div className="mn-page">
      <header className={`mn-header${scrolled ? " is-scrolled" : ""}`}>
        <div className="mn-header-top">
          <Link to="/" className="mn-back" aria-label="Girişe dön">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </Link>
          <div className="mn-header-titles">
            {restaurant?.FIRMA && <span className="mn-eyebrow">{restaurant.FIRMA}</span>}
            <h1 className="mn-title">Kategoriler</h1>
          </div>
        </div>
      </header>

      <main className="mn-main">
        <p className="ct-lead">
          {hasCategories ? `${categories.length} kategori · Görmek istediğinizi seçin` : "Menü hazırlanıyor…"}
        </p>
        <div className="ct-grid" aria-busy={!hasCategories}>
          {hasCategories
            ? categories.map((item, index) => (
                <CategoryCard id={id} category={item} key={item.CATEGORY || index} />
              ))
            : Array.from({ length: 8 }).map((_, i) => <div key={i} className="ct-tile mn-skeleton" />)}
        </div>
      </main>

      <MobresBacklink />
    </div>
  );
};

export default Category;
